// ViewerHeader.jsx
import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import logo from "../assets/logo.png"; // adjust the path if needed
import AttributionBox from "./AttributionBox";

const ViewerHeader = ({ system }) => {
  const headerRef = useRef(null);

  useEffect(() => {
    if (!headerRef.current) return;

    const updateHeaderHeight = () => {
      const height = headerRef.current.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        "--app-header-height",
        `${Math.ceil(height)}px`
      );
    };

    updateHeaderHeight();

    const observer = new ResizeObserver(updateHeaderHeight);
    observer.observe(headerRef.current);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty("--app-header-height");
    };
  }, []);

  return (
    <Box>
      <Box
        className="viewer-header"
        ref={headerRef}
        sx={{
          position: "absolute", // overlay on top of Unity web app
          top: 0,
          left: "env(safe-area-inset-left, 0px)",
          right: "env(safe-area-inset-right, 0px)",
          width: "auto",
          backgroundColor: "#212121", // dark background
          color: "#fff",
          px: "var(--viewer-header-px, 16px)", // overridable via CSS vars
          py: "var(--viewer-header-py, 10px)",
          minHeight: "var(--viewer-header-height, 80px)",
          zIndex: 1000, // ensure it appears on top
          overflowY: "auto",
          boxSizing: "border-box",
          boxShadow: 3,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          columnGap: "var(--viewer-header-gap, 12px)",
        }}
      >
        <Box width="33%" className="viewer-header__left">
          <Box sx={{ pl: 0, pt: 1, mb: 0 }} align="left">
            <img
              src={logo}
              alt="Logo"
              className="viewer-logo"
            />{" "}
          </Box>
        </Box>
        <Box width="33%" className="viewer-header__center">
          {/* <Typography sx={{mb:0}} variant="caption">CURRENT EXPERIENCE</Typography> */}
          {system && (
            <h3>{system?.name}</h3>
            // <Card label="Experience" content={system?.name} color="#7CFDFF" />
          )}
        </Box>
        <Box width="34%" className="viewer-header__right"></Box>

        {/* {currentEnvironment && (
        <Card
          label="Current environment"
          content={currentEnvironment.environmentName}
          description={currentEnvironment.description}
        />
      )} */}

        {/* {focusedElement && (
        <Card
          label="Selected element"
          variant="roundedColored"
          content={focusedElement.labelData.displayName}
          description={focusedElement.labelData.description}
        />
      )}
      {!focusedElement && (
        <Card
          label="Instructions"
          variant="rounded"
          content="Navigation"
          description="Scroll to zoom in and out. Click on objects to see more about them."
        />
      )}

      {!focusedElement && (
        <Card
          label="Instructions"
          variant="rounded"
          content="AI Guide"
          description="Enable your microphone to use the AI Guide. Answer the questions out loud and get an answer."
        />
      )} */}
      </Box>
      <AttributionBox />
    </Box>
  );
};

export default ViewerHeader;
